import { JsonObject, JsonProperty } from 'json-ts-mapper';

@JsonObject
export class DomiciliationBancaire {
  constructor (
    numTiers?: string,
    typeTiers?: string,
    numDomiciliationBancaire?: number,
    numeroBanque?: string,
    nomBanque?: string,
    numeroGuichet?: string,
    cleRib?: string,
    iban?: string,
    bic?: string
  ) {
    this.numTiers = numTiers as any;
    this.typeTiers = typeTiers as any;
    this.numDomiciliationBancaire = numDomiciliationBancaire as any;
    this.numeroBanque = numeroBanque as any;
    this.nomBanque = nomBanque as any;
    this.numeroGuichet = numeroGuichet as any;
    this.cleRib = cleRib as any;
    this.iban = iban as any;
    this.bic = bic as any;
  }

  @JsonProperty(String)
  numTiers?: string;

  @JsonProperty(String)
  typeTiers?: string;

  @JsonProperty(String)
  numDomiciliationBancaire?: string;

  @JsonProperty(String)
  numeroBanque?: string;

  @JsonProperty(String)
  nomBanque?: string;

  @JsonProperty(String)
  numeroGuichet?: string;

  @JsonProperty(String)
  numeroCompte?: string;

  @JsonProperty(String)
  cleRib?: string;

  @JsonProperty(String)
  iban?: string;

  @JsonProperty(String)
  bic?: string;

  get libelle (): string {
    return this.numeroCompte + this.cleRib + ' ' + this.nomBanque;
  }
}
